<template>
    <div ref="root">

        <div class="collapsible" data-collapsible ref="collapsible">
            <a href="#" class="collapsible__trigger" :class="{'collapsible__trigger--active' : collapsed}" data-collapsible-trigger>
                {{ title }}
            </a>
            <div class="collapsible__content" :class="{'collapsible__content--active' : collapsed}" data-collapsible-content>
                <div class="form__group" data-collapsible-body>
                    <div class="form__checkboxes">
                        <FilterItem v-for="item in shownFilters" :key="item.slug"
                                    :title="item.title"
                                    :active="item.active"
                                    :total="item.total"
                                    :slug="item.slug">
                        </FilterItem>
                        <a class="m-t-xs-10" href="#" @click.prevent="showMore=!showMore" v-if="items.length>5">
                            {{showMore?lessLabel:moreLabel}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FilterItem from "./FilterItem.vue"
import {computed, onMounted, ref, watchEffect} from 'vue'
import {useStore} from "vuex";

export default {
    name: "FilterList",
    props: ['title', 'items', 'slug'],
    components: {
        FilterItem,
    },
    setup(props) {
        let shownFilters = ref([]);
        let root = ref(null);
        let collapsible = ref(null);
        let showMore = ref(!(props.items.length > 5))
        const store = useStore();
        const moreLabel = computed(() => store.getters.data.copy.label_read_more)
        const lessLabel = computed(() => store.getters.data.copy.label_read_less)
        const activeCategories = computed(() => store.getters.activeCategories);
        const collapsed = props.items.filter((item, key) => {
            if (activeCategories.value.indexOf(item.slug) !== -1) {
                if(key > 4) {
                    showMore.value = true;
                }
                return true;
            }
        }).length > 0;

        onMounted(() => {
            // trigger initDom to get the collapsable functionalit
            window.initDom(root.value);
        })

        watchEffect(() => {
            let items = [...props.items];

            // Sort the items with count 0 last
            items.sort((a,b) => {
                if (a.total === 0) {
                    return 1;
                }
                else if (b.total === 0) {
                    return -1;
                }
            });

            if (props.items.length > 5 && !showMore.value) {

                shownFilters.value = [...items].slice(0, 5)
            } else {
                shownFilters.value = [...items]
            }

            if(collapsible.value) {
                const e = new CustomEvent('resize-content');
                collapsible.value.dispatchEvent(e);
            }
        })

        return {
            shownFilters,
            showMore,
            root,
            collapsible,
            collapsed,
            moreLabel,
            lessLabel,
        }
    }
}
</script>